export const TERMINATION_DETAILS_REASONS_LOAD = 'TERMINATION_DETAILS_REASONS_LOAD'
export const TERMINATION_DETAILS_REASONS_LOAD_PENDING = 'TERMINATION_DETAILS_REASONS_LOAD_PENDING'
export const TERMINATION_DETAILS_REASONS_LOAD_FULFILLED =
  'TERMINATION_DETAILS_REASONS_LOAD_FULFILLED'
export const TERMINATION_DETAILS_REASONS_LOAD_REJECTED = 'TERMINATION_DETAILS_REASONS_LOAD_REJECTED'
